import { Settings } from 'lucide-react';

import Github from '@/assets/ico/vendor/github.svg?c';
import Gitlab from '@/assets/ico/vendor/gitlab.svg?c';
import Bitbucket from '@/assets/ico/vendor/bitbucket.svg?c';
import Gitea from '@/assets/ico/vendor/gitea.svg?c';
import Azure from '@/assets/ico/vendor/azure.svg?c';

import { BoxSelector, type BoxSelectorOption } from '@@/BoxSelector';

import { Provider } from '../types';

const providerOptions: BoxSelectorOption<Provider>[] = [
  {
    id: 'github',
    icon: Github,
    iconType: 'logo',
    label: 'GitHub',
    value: Provider.GitHub,
  },
  {
    id: 'gitlab',
    icon: Gitlab,
    iconType: 'logo',
    label: 'GitLab',
    value: Provider.GitLab,
  },
  {
    id: 'bitbucket-cloud',
    icon: Bitbucket,
    iconType: 'logo',
    label: 'Bitbucket Cloud',
    value: Provider.BitbucketCloud,
  },
  {
    id: 'bitbucket-data-center',
    icon: Bitbucket,
    iconType: 'logo',
    label: 'Bitbucket Data Center',
    value: Provider.BitbucketDataCenter,
  },
  {
    id: 'azure-devops',
    icon: Azure,
    iconType: 'logo',
    label: 'Azure DevOps',
    value: Provider.AzureDevOps,
  },
  {
    id: 'gitea-forgejo',
    icon: Gitea,
    iconType: 'logo',
    label: 'Gitea / Forgejo',
    value: Provider.GiteaForgejo,
  },
  {
    id: 'custom',
    icon: Settings,
    iconType: 'logo',
    label: 'Custom',
    value: Provider.Custom,
  },
];

type Props = {
  value: Provider;
  onChange: (provider: Provider) => void;
};

export function GitProviderSelector({ value, onChange }: Props) {
  return (
    <BoxSelector
      radioName="Provider"
      options={providerOptions}
      value={value}
      onChange={onChange}
    />
  );
}
